import React, { forwardRef, useContext, useImperativeHandle, useState, } from 'react';
import { CnSearch } from '../../cn-search';
import isFunction from 'lodash/isFunction';
import SelectContext from '../context';
const SelectSearch = (props, ref) => {
    const { prefix, setSearchValue, value: searchValue, innerValue, onSearch: contextSearch, searchLoading, } = useContext(SelectContext);
    const { onSearch } = props;
    const [value, setValue] = useState('');
    useImperativeHandle(ref, () => ({
        setValue(v) {
            setValue(v);
            setSearchValue(v);
        },
    }));
    const handleSearch = (v) => {
        setValue(v);
        setSearchValue(v);
        if (isFunction(onSearch)) {
            onSearch(v);
        }
        if (isFunction(contextSearch)) {
            // @ts-ignore
            contextSearch(v, searchValue, innerValue);
        }
    };
    return (React.createElement("div", { className: `${prefix}select-search-wrapper`, style: { width: '100%', height: '100rpx' } },
        React.createElement(CnSearch, { value: value, hasClear: true, onChange: handleSearch, onClear: () => {
                handleSearch('');
            }, loading: searchLoading })));
};
export default forwardRef(SelectSearch);
